export function getOtherLocale (i18n) {
  const { locale } = i18n
  return i18n.locales.filter(l => l.code !== locale)[0]?.code || locale
}
